import { Injectable } from '@angular/core';
import { StorageKey, StorageService } from './storage.service';
import { ContentService } from './content.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ActivationService {
  constructor(
    private storageService: StorageService,
    private contentService: ContentService,
  ) {}

  async verifyCode(code: string): Promise<boolean> {
    const codeCollectionResponse = await lastValueFrom(this.contentService.getAccessCodes());
    const codes = codeCollectionResponse.data.map((a) => a.attributes.code.toLocaleLowerCase());
    return codes.includes(code.toLocaleLowerCase());
  }

  isActivated(): boolean {
    return this.storageService.get(StorageKey.ACTIVATED);
  }

  setActivated(value = true) {
    return this.storageService.set(StorageKey.ACTIVATED, value);
  }
}
